import Vue from 'vue'
import VueRouter from 'vue-router'

import HomePage from '../components/home-page'
import OurApproachPage from '../components/our-approach-page'
import PlansPage from '../components/plans-page'
import DetailsPage from '../components/details-page'
import UnderConstructionPage from '../components/under-construction-page'
import Page404 from '../components/page-404'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: HomePage,
    },
    {
      path: '/our-approach',
      component: OurApproachPage,
    },
    {
      path: '/plans',
      component: PlansPage,
    },
    {
      path: '/details',
      component: DetailsPage,
    },
    {
      path: '/demo',
      component: UnderConstructionPage,
    },
    {
      path: '/login-signup',
      component: UnderConstructionPage,
    },
    {
      path: '/*',
      component: Page404,
    },
  ],
})
